import React from 'react';
import { ImLinkedin } from "react-icons/im";
import { FaGithub } from "react-icons/fa6";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href='https://www.linkedin.com/in/hajjimedamine/'>
        <ImLinkedin />
      </a>
    </div>
    
    <div>
      <a href='https://github.com/MedAmineHajji'>
        <FaGithub />
      </a>
    </div>
  </div>
);

export default SocialMedia;